<template>
  <div class="support">
      <h2>پشتیبانی از تمام کوین ها</h2>
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک
        از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
        استفاده می نماید.
      </p>
    </div>
</template>

<script>
export default {
  name: "the-support-coins-text"
}
</script>

<style lang="scss" scoped>
.support {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  gap: 20px;
  //margin-top: 130px;
  flex-wrap: wrap;
  background-image: url("../../assets/Home/COINS.png");
  background-position: left center;
  background-size: auto;
  background-repeat: no-repeat;
  height: 626px;

    h2{
      font-size: clamp(18px , 2vw , 24px);
      color: #FBFBFD;
      text-align: right;
      position: relative;
      right: 100px;
      width: 20%;
    }

    p{
      font-size: clamp(14px , 2vw , 16px);
      color: #FBFBFD;
      text-align: right;
      position: relative;
      right: 100px;
      width: 30%;
    }
  }

@media (max-width: 992px) {
  .support p{
    width: 70%;
    right: 20px;
  }

  .support h2{
    width: 70%;
    right: 20px;
  }
}
</style>